import {
  id,
  Identifiable,
  project,
  Project,
  projectReport,
  ProjectReport,
  zone,
  Zone,
} from "@planzone/dto";

type ZoneProjectReport = {
  zone: Identifiable<Zone>;
  project: Identifiable<Project>;
  report: Identifiable<ProjectReport>;
};
const zoneProjectReport: ZoneProjectReport = {
  project: { ...project, uuid: id },
  report: { ...projectReport, uuid: id },
  zone: { ...zone, uuid: id },
};

export type { ZoneProjectReport };

export { zoneProjectReport };
